"use client";
// Import necessary libraries and modules
import Image from "next/image";
import React, { useState } from "react";

const ReadMore = ({ children }) => {
  const text = children;
  const [isReadMore, setIsReadMore] = useState(true);

  // Toggle the Read More state
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  // rohailjohn
  return (
    <>
      <div
        className={`${isReadMore ? "line-clamp-5" : ""} overflow-hidden`}
        style={{
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          textOverflow: "ellipsis",
          whiteSpace: "normal",
        }}
      >
        {/* {text} */}
        <p
          dangerouslySetInnerHTML={{ __html: text }}
          className="updatedparapremu pt-6"
        ></p>
      </div>
      {text.length > 380 && (
        <div
          onClick={toggleReadMore}
          className="style-redmore"
          style={{
            color: "#D5AF34",
            fontSize: "17px",
            display: "inline-block",
            marginLeft: "1px",
            cursor: "pointer",
          }}
        >
          {isReadMore ? "Read More" : "Show less"}
        </div>
      )}
    </>
  );
};

function Cards({ Mydata }) {
  const data = Mydata[1];

  return (
    <>
      <div>
        <div className="mx-auto max-w-7xl  pt-10">
          <div className="text-center px-6">
            <h2 className="text-3xl secondary font-bold">
              <span>{data.subtitle}</span>
              <span className="text-[#D5AF34]"> {data.title}</span>
            </h2>
            <div className="display">
              <p
                dangerouslySetInnerHTML={{ __html: data.des }}
                className="updatedparapremu display pt-6"
              ></p>
              {/* <p className="updatedparapremu pt-6">{data.des}</p> */}
            </div>

            <div className="display-desktop">
              <ReadMore maxLines={5}>{data.des}</ReadMore>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="mx-auto max-w-7xl pt-10 mb-7">
          <div className="grid      grid-cols-1 sm:grid-cols-1 md:grid-cols-1   lg:grid-cols-2 gap-9 px-6">
            {data.slider.map((items, index) => (
              <div key={index} className="rounded-2xl slie p-4">
                <div>
                  <Image
                    src={items.image}
                    height={170}
                    width={700}
                    alt={items.alt}
                    title={items.tle}
                    className="mb-3"
                    loading="lazy"
             
                  />
                </div>
                <h2 className="updatedheading mb-3">{items.title}</h2>
                <div className="updatedparapremu">
                  <ReadMore maxLines={5}>{items.des}</ReadMore>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

// Export the Cards component
export default Cards;
